import React from 'react';
import { FicheAutoControleCritere } from '../../../store/types/FicheAutocontrole.Types';
import { ApplicationState } from '../../../store/store/store';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { GoBackCurrentState, GoBackCurrentStateActions } from '../../../store/types/GoBackState.Types';
import { connect } from 'react-redux';

interface PropsFromState {
    critere: FicheAutoControleCritere,
    updateCritere: Function
}

interface PropsFromDispatch {
    goBackStateHasChanged: Function,
    goBackState: GoBackCurrentState
}

type AllProps = PropsFromDispatch & PropsFromState

const CounterAutocontrole: React.FC<AllProps> = ({ critere, updateCritere, goBackStateHasChanged }) => {

    const handleIncrement = () => {
        goBackStateHasChanged();
        critere.value = (critere.value || 0) as number + 1;
        updateCritere(critere);
    }

    const handleDecrement = () => {
        if (critere.value && critere.value as number > 0) {
            goBackStateHasChanged();
            critere.value = critere.value as number - 1;
            updateCritere(critere);
        }
    }

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = parseInt(event.target.value, 10);
        goBackStateHasChanged();
        critere.value = !isNaN(newValue) ? newValue : 0;
        updateCritere(critere);
    };

    return (<div className="counter-bloc">
        <button className="counter-decrement-button" onClick={handleDecrement}>-</button>
        <input className="counter-editor" value={critere.value ? critere.value as number : 0} onChange={handleChange}/>
        <button className="counter-increment-button" onClick={handleIncrement}>+</button>
    </div>
    );
};


const mapStateToProps = ({ goBackState }: ApplicationState) => ({
    goBackState: goBackState
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
    return {
        goBackStateHasChanged: () => dispatch({ type: GoBackCurrentStateActions.CHANGING_STATE })
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(CounterAutocontrole);